import axios from '@/libs/api.request'

// 获取客服电话
export const getServicePhone = () => {
  return axios.request({
    url: 'option/phoneget',
    method: 'post'
  })
}

// 更新客服电话
export const updateServicePhone = (data) => {
  return axios.request({
    url: 'option/phoneUpdate',
    data: data,
    method: 'post'
  })
}

// 获取仪表盘数据
export const getDashboardData = () => {
  return axios.request({
    url: 'dashboard/data',
    method: 'get'
  })
}